import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FavoriteService {
  constructor(private httpClient: HttpClient) {}

  public hasUpdated: Subject<boolean> = new Subject<boolean>();

  public setUpdated(sub: boolean): void {
    this.hasUpdated.next(sub);
  }

  public favoriteThreatProfile = (uuid: string): Observable<void> => {
    return this.httpClient.post<void>(
      `${environment.api}/es/cyborg-threat-profile/${uuid}/favorite`,
      {}
    );
  };

  public unfavoriteThreatProfile = (uuid: string): Observable<void> => {
    return this.httpClient.post<void>(
      `${environment.api}/es/cyborg-threat-profile/${uuid}/unfavorite`,
      {}
    );
  };

  public favoriteHuntPackage = (uuid: string): Observable<void> => {
    return this.httpClient.post<void>(
      `${environment.api}/es/cyborg-hunt-package/${uuid}/favorite`,
      {}
    );
  };

  public unfavoriteHuntPackage = (uuid: string): Observable<void> => {
    return this.httpClient.post<void>(
      `${environment.api}/es/cyborg-hunt-package/${uuid}/unfavorite`,
      {}
    );
  };

  public checkThreatProfileFavorite = (uuid: string): Observable<boolean> => {
    return this.httpClient.get<boolean>(
      `${environment.api}/es/cyborg-threat-profile/${uuid}/favorite`,
      {}
    );
  };

  public checkHuntPackageFavorite = (uuid: string): Observable<boolean> => {
    return this.httpClient.get<boolean>(
      `${environment.api}/es/cyborg-hunt-package/${uuid}/favorite`,
      {}
    );
  };
}
